import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import SubscriptionTabs from "./SubscriptionsTabs";

const initialFieldValues = {
  subscriptionPlanId: "00000000-0000-0000-0000-000000000000",
  planType: "",
  planName: "",
  price: 0,
  billingCycle: "",
  razorpayPlanId: "",
  isActive: true,
};

const SubscriptionPlans = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [addShow, setAddShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
    setValues(initialFieldValues);
  };

  const handleAddShow = () => {
    setRecordForEdit(null);
    setValues(initialFieldValues);
    setAddShow(true);
  };

  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAddShow(true);
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  const GetData = async () => {
    const res = await apiService.getSingle(config.GETALLSUBSCRIPTIONPLANS);
    setLists(res);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(
          config.DELETESUBSCRIPTIONPLAN,
          itemToDelete
        );
        await GetData();
      } catch (error) {}
      handleCloseDeleteModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.planType = values.planType === "" ? false : true;
    temp.planName = values.planName === "" ? false : true;
    temp.price = values.price === "" || values.price < 0 ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      const formData = {
        subscriptionPlanId: values.subscriptionPlanId,
        planType: values.planType,
        planName: values.planName,
        price: parseFloat(values.price),
        billingCycle: values.billingCycle,
        razorpayPlanId: values.razorpayPlanId,
        isActive: values.isActive,
      };
      try {
        const isNew =
          formData.subscriptionPlanId ===
          "00000000-0000-0000-0000-000000000000";
        if (isNew) {
          await apiService.create(config.CREATESUBSCRIPTIONPLAN, formData);
        } else {
          await apiService.update(config.UPDATESUBSCRIPTIONPLAN, formData);
        }
        await GetData();
        resetForm();
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setValues({
      ...values,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    if (user && !loading) {
      GetData();
    }
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) navigate("/");

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                 <div className="p-2">
                                                <SubscriptionTabs pageName="SUBSCRIPTION PLANS" />
                                            </div>
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h5 className="mb-0">Subscription Plans</h5>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleAddShow}
                  >
                    <i className="ri-add-line align-bottom me-1" /> Add Plan
                  </button>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>S.No</th>
                          <th>Plan Type</th>
                          <th>Plan Name</th>
                          <th>Price (INR)</th>
                          <th>Billing Cycle</th> 
                           <th>Razorpay Plan ID</th>
                          <th>Status</th>
                          <th>Created Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.length > 0 ? (
                          lists.map((v, index) => (
                            <tr key={v.subscriptionPlanId}>
                              <td>{index + 1}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    v.planType === "Trial"
                                      ? "bg-secondary"
                                      : v.planType === "Basic"
                                      ? "bg-info"
                                      : v.planType === "Starter"
                                      ? "bg-success"
                                      : "bg-primary"
                                  }`}
                                >
                                  {v.planType}
                                </span>
                              </td>
                              <td>{v.planName}</td>
                              <td>
                                {v.price === 0 ? (
                                  <span className="text-success fw-semibold">
                                    Free
                                  </span>
                                ) : (
                                  `INR ${v.price}`
                                )}
                              </td>
                              <td>{v.billingCycle}</td>
<td>{v.razorpayPlanId}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    v.isActive ? "bg-success" : "bg-danger"
                                  }`}
                                >
                                  {v.isActive ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td>
                                {new Date(v.createdDate).toLocaleDateString()}
                              </td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li className="list-inline-item">
                                    <Link
                                      className="edit-item-btn"
                                      onClick={() => showEditDetails(v)}
                                    >
                                      <i className="ri-pencil-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                  <li className="list-inline-item">
                                    <Link
                                      className="remove-item-btn"
                                      onClick={() =>
                                        handleOpenDeleteModal(
                                          v.subscriptionPlanId
                                        )
                                      }
                                    >
                                      <i className="ri-delete-bin-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center text-muted">
                              No subscription plans found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add / Edit Modal */}
        <Modal show={addShow} onHide={handleAddClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {values.subscriptionPlanId ===
              "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              Subscription Plan
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                {/* Plan Type */}
                <div className="col-lg-12 mb-3">
                  <label className="form-label">Plan Type</label>
                  <select
                    name="planType"
                    value={values.planType}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("planType")}
                  >
                    <option value="">-- Select Plan Type --</option>
                    <option value="Trial">Trial</option>
                    <option value="Micro">Micro</option>
                    <option value="Basic">Basic</option>
                    <option value="Starter">Starter</option>
                    <option value="Enterprise">Enterprise</option>
                  </select>
                  {errors.planType === false && (
                    <div className="validationerror">
                      Please select plan type
                    </div>
                  )}
                </div>

                {/* Plan Name */}
                <div className="col-lg-12 mb-3">
                  <label className="form-label">Plan Name</label>
                  <input
                    type="text"
                    name="planName"
                    value={values.planName}
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("planName")}
                    placeholder="e.g. Basic Plan"
                    maxLength={100}
                  />
                  {errors.planName === false && (
                    <div className="validationerror">
                      Please enter plan name
                    </div>
                  )}
                </div>

                {/* Price */}
                <div className="col-lg-12 mb-3">
                  <label className="form-label">Price (₹)</label>
                  <input
                    type="number"
                    name="price"
                    value={values.price}
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("price")}
                    placeholder="0 for free plans"
                    min={0}
                  />
                  {errors.price === false && (
                    <div className="validationerror">
                      Please enter a valid price
                    </div>
                  )}
                </div>
                <div className="col-lg-12 mb-3">
  <label className="form-label">Billing Cycle</label>

  <select
    name="billingCycle"
    value={values.billingCycle}
    onChange={handleInputChange}
    className={
      "form-select" + applyErrorClass("billingCycle")
    }
  >
    <option value="">-- Select Billing Cycle --</option>
    <option value="Weekly">Weekly</option>
    <option value="Monthly">Monthly</option>
    <option value="Yearly">Yearly</option>
  </select>

  {errors.billingCycle === false && (
    <div className="validationerror">
      Please select billing cycle
    </div>
  )}
</div>

<div className="col-lg-12 mb-3">
  <label className="form-label">
    Razorpay Plan ID
  </label>

  <input
    type="text"
    name="razorpayPlanId"
    value={values.razorpayPlanId}
    onChange={handleInputChange}
    className={
      "form-control" +
      applyErrorClass("razorpayPlanId")
    }
    placeholder="plan_xxxxxxxxx"
  />

  {errors.razorpayPlanId === false && (
    <div className="validationerror">
      Please enter Razorpay Plan ID
    </div>
  )}
</div>
                {/* Is Active */}
                <div className="col-lg-12 mb-3">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="isActive"
                      id="isActive"
                      checked={values.isActive}
                      onChange={handleInputChange}
                    />
                    <label className="form-check-label" htmlFor="isActive">
                      Active
                    </label>
                  </div>
                </div>
              </div>

              <Modal.Footer>
                <div className="hstack gap-2 justify-content-end">
                  {btnLoading === false ? (
                    <button type="submit" className="btn btn-primary">
                      {values.subscriptionPlanId ===
                      "00000000-0000-0000-0000-000000000000"
                        ? "Submit"
                        : "Update"}
                    </button>
                  ) : (
                    <button type="submit" className="btn btn-primary" disabled>
                      Please wait...
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                </div>
              </Modal.Footer>
            </form>
          </Modal.Body>
        </Modal>

        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default SubscriptionPlans;